import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { isElementAccessExpression } from 'typescript';
import { environment } from '../../../../environments/environment';
import { AppSettings } from '../../../shared/PRE-LOAD/app-settings';
import { ReservationService } from '../../../shared/services/reservation/reservation.service';
import { UserSelectionsService } from '../../../shared/services/user-selections/user-selections.service';
import { Product } from '../../../shared/types/product.type';
import { Journey, JourneySteps } from '../../../shared/types/strings.type';
import { JourneyConfig } from '../../config/journey';
import { AnalyticsService } from '../../../shared/services/analytics/analytics.service';

@Component({
    selector: 'event-personal-information',
    templateUrl: './event-personal-information.component.html',
    styles: [
        require('./event-personal-information.component.scss').default.toString(),
        require(`./event-personal-information.component.${environment.brand}.scss`).default.toString(),
        require('../../styles.event.scss').default.toString(),
    ],
})
export class EventPersonalInformationComponent implements OnInit {
    // Whether or not the user details component form has valid input.
    isValid = false;
    event: Product;
    header: Journey = {
        title: 'Book Event',
        instruction: 'Enter your booking details.'
    };
    journeySteps: Array<JourneySteps> = JourneyConfig.steps;

    links = {
        retailerTermsAndConditions: this.appSettings.retailerTermsAndConditions,
        retailerPrivacyPolicyUrl: this.appSettings.retailerPrivacyPolicyUrl
    };
    startTime: Date;

    constructor(
        private reservationService: ReservationService,
        private router: Router,
        private appSettings: AppSettings,
        private userSelectionService: UserSelectionsService,
        private analytics: AnalyticsService

    ) {
    }

    ngOnInit() {
        this.event = this.userSelectionService.get('product');
        let eventTitle =  this.userSelectionService.get('product');
        this.startTime = this.userSelectionService.get('startTime');

        this.header = {
            title: `Book an appointment`,
            instruction: `${eventTitle.title} Appointment`
        };


        let event =  this.userSelectionService.get('product');

        this.header = {
            title: `Book an appointment`,
            instruction: `${event.title} Appointment`
        };





        this.analytics.setFormStep('Personal Details');

    }

    proceed() {
        if (this.isValid) {


            this.reservationService.postReservation().subscribe(
                response => {
                    if (response) {
                        this.analytics.formCompleted();

                        this.router.navigate(['event-confirmation'], { skipLocationChange: true, fragment: 'rttd' });
                    }
                }
            );
        }
    }

    changeAppointment() {
        this.router.navigate(['/event-appointment'], { skipLocationChange: true });
    }

    onIsValid(valid: boolean) {
        this.isValid = valid;
    }

    onValidationError(errors: any){
        this.analytics.formError(errors);
    }

}
